// added to master
//2
  //Focus on the Next Field
  export const handleEnter = (event) => {
    if (event.key.toLowerCase() === "enter") {
      const form = event.target.form;
      const index = [...form].indexOf(event.target);
      form.elements[index + 1].focus();
      event.preventDefault();
    }
  };

  export const keyPress = (e,loginHandler) => {
    if (e.keyCode === 13) {
      loginHandler(e)
    }
  }

// تابع تبدیل اعداد فارسی به انگلیسی
  export const convertToEnglishNumbers  = (value) => {
    return value.replace(/[۰-۹]/g, (char) =>
      String.fromCharCode(char.charCodeAt(0) - 1728)
    );
  }
  

